// Requisitos operativos de montaje (zona → snapshot editable en la línea). Sólo información física/operativa, sin economía.
export const DIFICULTADES = [
  { value: "normal", label: "Normal" }, { value: "media", label: "Media" }, { value: "alta", label: "Alta" }, { value: "especial", label: "Especial" },
];
export const MEDIOS = [
  { value: "ninguno", label: "Ninguno" }, { value: "escalera", label: "Escalera" }, { value: "escalera_alta", label: "Escalera alta" },
  { value: "andamio", label: "Andamio" }, { value: "plataforma_elevadora", label: "Plataforma elevadora" }, { value: "grua", label: "Grúa" }, { value: "otro", label: "Otro" },
];
export const MEDIOS_ESPECIALES = new Set(["escalera_alta", "andamio", "plataforma_elevadora", "grua", "otro"]);
export const medioLabel = (v, otro) => (v === "otro" && otro ? otro : (MEDIOS.find((m) => m.value === v)?.label || v || ""));
export const dificultadLabel = (v) => DIFICULTADES.find((d) => d.value === v)?.label || v || "";

export const REQ_VACIO = { material_habitual: "", personas_minimas: "", dificultad: "", medio_acceso: "", medio_acceso_otro: "", ventana_horaria: { desde: "", hasta: "", texto: "" }, instrucciones_montaje: "", precauciones: "", tiempo_estimado_min: "" };

/** Form state → payload API (null si no hay nada informado). */
export const aPayloadRequisitos = (r) => {
  if (!r) return null;
  const vh = r.ventana_horaria || {};
  const out = {
    material_habitual: r.material_habitual?.trim() || null,
    personas_minimas: r.personas_minimas !== "" && r.personas_minimas != null ? Math.max(1, parseInt(r.personas_minimas, 10) || 1) : null,
    dificultad: r.dificultad || null, medio_acceso: r.medio_acceso || null,
    medio_acceso_otro: r.medio_acceso === "otro" ? (r.medio_acceso_otro?.trim() || null) : null,
    ventana_horaria: (vh.desde || vh.hasta || vh.texto) ? { desde: vh.desde || null, hasta: vh.hasta || null, texto: vh.texto?.trim() || null } : null,
    instrucciones_montaje: r.instrucciones_montaje?.trim() || null, precauciones: r.precauciones?.trim() || null,
    tiempo_estimado_min: r.tiempo_estimado_min !== "" && r.tiempo_estimado_min != null ? parseInt(r.tiempo_estimado_min, 10) || null : null,
  };
  return Object.values(out).some((v) => v !== null) ? out : null;
};
/** Payload API → form state. */
export const aFormRequisitos = (r) => ({
  ...REQ_VACIO, ...(r || {}),
  personas_minimas: r?.personas_minimas ?? "", tiempo_estimado_min: r?.tiempo_estimado_min ?? "",
  material_habitual: r?.material_habitual || "", dificultad: r?.dificultad || "", medio_acceso: r?.medio_acceso || "", medio_acceso_otro: r?.medio_acceso_otro || "",
  instrucciones_montaje: r?.instrucciones_montaje || "", precauciones: r?.precauciones || "",
  ventana_horaria: { desde: r?.ventana_horaria?.desde || "", hasta: r?.ventana_horaria?.hasta || "", texto: r?.ventana_horaria?.texto || "" },
});
export const requisitosIguales = (a, b) => JSON.stringify(aPayloadRequisitos(a)) === JSON.stringify(aPayloadRequisitos(b));
export const hayRequisitos = (r) => !!aPayloadRequisitos(r);

export const ventanaTexto = (vh) => {
  if (!vh) return "";
  if (vh.desde && vh.hasta) return `${vh.desde}–${vh.hasta}`;
  if (vh.hasta) return `antes ${vh.hasta}`;
  if (vh.desde) return `desde ${vh.desde}`;
  return vh.texto || "";
};

/** Chips cortos para tarjetas: [{k, txt, tone}] — sólo lo que existe. personas=1 se omite. */
export const chipsRequisitos = (req) => {
  if (!req) return [];
  const out = [];
  if ((req.personas_minimas || 1) > 1) out.push({ k: "personas", txt: `👥${req.personas_minimas}`, tone: "amber" });
  if (req.dificultad === "alta" || req.dificultad === "especial") out.push({ k: "dificultad", txt: `⚠ ${dificultadLabel(req.dificultad)}`, tone: "rose" });
  else if (req.dificultad === "media") out.push({ k: "dificultad", txt: "Media", tone: "zinc" });
  if (req.medio_acceso && MEDIOS_ESPECIALES.has(req.medio_acceso)) out.push({ k: "medio", txt: `🪜 ${medioLabel(req.medio_acceso, req.medio_acceso_otro)}`, tone: "cyan" });
  const vt = ventanaTexto(req.ventana_horaria);
  if (vt) out.push({ k: "horario", txt: `🕒 ${vt}`, tone: "zinc" });
  return out;
};
/** Resumen 1 línea: "Duratrans · 👥2 · ⚠ Alta · 09:00–10:00" */
export const resumenRequisitos = (req) => {
  if (!req) return "";
  return [req.material_habitual, ...chipsRequisitos(req).map((c) => c.txt.replace(/^🕒 |^🪜 /, ""))].filter(Boolean).join(" · ");
};

/** Aviso informativo por ruta (no bloquea): personal mínimo y medios especiales de sus paradas. */
export const resumenRequisitosParadas = (paradas) => {
  const reqs = (paradas || []).map((p) => p.requisitos_montaje).filter(Boolean);
  const conPersonal = reqs.filter((r) => (r.personas_minimas || 1) > 1);
  const medios = {};
  reqs.forEach((r) => { if (r.medio_acceso && MEDIOS_ESPECIALES.has(r.medio_acceso)) medios[r.medio_acceso] = (medios[r.medio_acceso] || 0) + 1; });
  const dificiles = reqs.filter((r) => r.dificultad === "alta" || r.dificultad === "especial").length;
  if (!conPersonal.length && !Object.keys(medios).length && !dificiles) return null;
  return {
    nPersonal: conPersonal.length, personasMax: Math.max(1, ...conPersonal.map((r) => r.personas_minimas)),
    medios: Object.entries(medios).map(([medio, n]) => ({ medio, n, label: medioLabel(medio) })), dificiles,
  };
};
